import BaseModel from "@/store/models/base";

export default class GiftCardModel extends BaseModel {
  /**
   * {@inheritDoc}
   * */
  getSchema() {
    return {
      id: "",
      image: "",
      message: "",
      name: "",
      price: "",
      product_id: null,
    };
  }

  /**
   * Retorna o valor do cartão.
   *
   * @return {number}
   * */
  get price() {
    return +this.rawAttributes.price || 0;
  }
}
